import { ButtonConfig } from "../constants/Constants";
import { Paths } from "../constants/UrlConstants";

const MakeAClaimSmartLink = {
  linkText: "Make a claim",
  pathTo: Paths.MakeAClaim,
  iconName: "icon-health-health-kit",
  id: ButtonConfig.MakeAclaim
};

export default MakeAClaimSmartLink;
